import React, { useEffect, useState } from "react";
import { Mic, Sparkles, History } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, SectionCard, EmptyState } from "@/components/Primitives";
import { ClinicalBanner } from "@/components/Disclaimer";
import DataTable from "@/components/DataTable";

export default function VoiceEngine() {
  const [sessions, setSessions] = useState([]);

  useEffect(() => { api.get("/voice/sessions").then(r => setSessions(r.data)); }, []);

  const cols = [
    { key: "session_type", label: "Type" },
    { key: "transcript_text", label: "Transcript", render: (r)=>(r.transcript_text||"").slice(0,80) + "…" },
    { key: "created_at", label: "Captured", render: (r)=>new Date(r.created_at).toLocaleString() },
    { key: "processed_at", label: "Processed", render: (r)=>r.processed_at?new Date(r.processed_at).toLocaleTimeString():"—" },
  ];

  return (
    <>
      <PageHeader eyebrow="Module 14" title="Voice Intelligence Engine"
        subtitle="Ambient capture + Claude topology analysis. Tap the purple microphone in the bottom-right corner of any page to start a session."
        testid="voice-page" />
      <ClinicalBanner />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <FeatureCard icon={Mic} title="Ambient Capture" body="Live Web Speech API transcription with continuous mode." />
        <FeatureCard icon={Sparkles} title="Topology Analysis" body="SOAP, ICD-10, CPT, referrals, PAs, meds, follow-ups, orders, risk flags." accent />
        <FeatureCard icon={History} title="Voice Memory" body="All sessions linked to patient — longitudinal summary." />
      </div>

      <SectionCard title="Session History" testid="voice-sessions">
        {sessions.length === 0 ? (
          <EmptyState icon={Mic} title="No voice sessions yet" hint="Tap the floating mic in the bottom right to start ambient capture." />
        ) : (
          <DataTable data={sessions} columns={cols} searchKeys={["transcript_text","session_type"]} testid="voice-sessions-table" />
        )}
      </SectionCard>
    </>
  );
}

const FeatureCard = ({ icon: Icon, title, body, accent }) => (
  <div className="kpi-card">
    <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${accent?"bg-brand-teal":"bg-brand-bg"}`}>
      <Icon className={`w-5 h-5 ${accent?"text-white":"text-brand-primary"}`} strokeWidth={1.6} />
    </div>
    <div className="text-sm font-semibold">{title}</div>
    <div className="text-xs text-brand-muted mt-1">{body}</div>
  </div>
);
